import { render, staticRenderFns } from "./stores-item.vue?vue&type=template&id=7d633a93&scoped=true"
import script from "./stores-item.vue?vue&type=script&lang=js"
export * from "./stores-item.vue?vue&type=script&lang=js"
import style0 from "./stores-item.vue?vue&type=style&index=0&id=7d633a93&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d633a93",
  null
  
)

export default component.exports